import React, {
    FunctionComponent as FC,
    useRef,
  } from 'react';
  import './index.scss';

  import { Spin } from 'antd';
  import { GlobalStyle } from '../../../../types/style';
  import { MainViewTypes } from '../../../../types/data';

  import TableCell from './TableCell';

  var numeral = require('numeral');

  const fmtUSD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0, // 按需改成 2
  });

  interface ImpactSummaryTableProps {
    data: MainViewTypes.ImpactSummaryViewData;
  }

  const ImpactSummaryTable: FC<ImpactSummaryTableProps> = (props) => {
    const { data } = props

    // console.log('ImpactSummaryTable: ', data)

    // // loading related
    // const isMainviewLoading: boolean = useSelector((state: State) => state.dataReducer?.isMainviewLoading) as boolean
    // // ui reducer
    // const tooltipData = useSelector((state: State) => state.uiReducer?.treemapTooltip) as {
    //   tooltipData: TooltipTypes.TooltipData,
    //   tooltipPosition: TooltipTypes.TooltipPosition,
    //   tooltipOpacity: number;
    // }
    // const paperMatrixData: MatrixTypes2.CellUnit[] = matrixData.paperMatrix
    // const patentTreemapData: MatrixTypes2.TreemapUnit[] = matrixData.patentTreemap
    // const paperPatentFlowData: MatrixTypes2.FlowUnit[] = matrixData.paperPatentFlow
    // // console.log('paperMatrixData: ', paperMatrixData)


    const firstRowAttrList: string[] = [
      'fundingAmount', 'numGrant',
      'numPaper', 'numPatent', 'numClinicalTrial',
    ]
    // const secondRowAttrList: string[] = [
    //   'numPaper', 'numPatent', 'numClinicalTrial',
    // ]
    const thirdRowAttrList: string[] = [
      'numCitingPaper', 'numCitingPatent', 'numCitingClinicalTrial', 'numCitingPolicy', 'numCitingNews',
    ]

    const firstRowElementList: JSX.Element[] = firstRowAttrList.map(
      (attrName: string, index: number) => <TableCell key={index} attrName={data[attrName].attrName} attrValue={
        // numeral(data[attrName].attrValue).format('0,0')
        attrName === 'fundingAmount'
        ? `${numeral(data[attrName].attrValue).format('0,0')} USD`
        : numeral(data[attrName].attrValue).format('0,0')
      }/>
    )
    // const secondRowElementList: JSX.Element[] = secondRowAttrList.map(
    //   (attrName: string, index: number) => <TableCell key={index} attrName={data[attrName].attrName} attrValue={numeral(data[attrName].attrValue).format('0,0')}/>
    // )
    const thirdRowElementList: JSX.Element[] = thirdRowAttrList.map(
      (attrName: string, index: number) => <TableCell key={index + 5} attrName={data[attrName].attrName} attrValue={numeral(data[attrName].attrValue).format('0,0')}/>
    )

    const allElementList: JSX.Element[] = [...firstRowElementList, ...thirdRowElementList]

    return (
      <div className='impact-summary-table-div'>
        <div className='title-div'>Summary</div>
        <div className='content-div-adjusted'>
          { allElementList }
        </div>
        {/* <div className='content-div'>
            <div className='first-row'>{ firstRowElementList }</div>
            <div className='second-row'>{ secondRowElementList }</div>
            <div className='third-row'>{ thirdRowElementList }</div>
        </div> */}
      </div>
    )
  }

  export default ImpactSummaryTable;